import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

// import { MatSortable } from '@angular/material/sort';
import { Client, Fund, User } from './master-cliente-visualizar-cliente.model';
import { MasterVisualizarClienteService } from './master-cliente-visualizar-cliente.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { MasterVisualizarClienteComponent } from '../visualizar-cliente/master-visualizar-cliente.component';
import { MatSort, MatSortable } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

/**
 * This Component manages the presentation logic of a view screen
 *
 */
@Component({
  selector: 'app-master-cliente-visualizar-cliente',
  templateUrl: './master-cliente-visualizar-cliente.component.html',
})
export class MasterClienteVisualizarClienteComponent implements OnInit {
  id: any;
  client: Client;
  users: MatTableDataSource<User>;
  funds: MatTableDataSource<Fund>;

  usersComplete: any;
  fundsComplete: any;

  usersColumns = ['name', 'login', 'permissionGroups', 'status', 'edit'];
  fundsColumns = ['code', 'name'];

  @ViewChild('sortUsers', { static: false }) sortUsers: MatSort;
  @ViewChild('sortFunds', { static: false }) sortFunds: MatSort;

  userFilter: any;
  fundFilter: any;

  subscription: Subscription;

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private clientService: MasterVisualizarClienteService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<MasterVisualizarClienteComponent>,
  ) { }

  ngOnInit() {
    this.getClient();
  }

  getClient() {
    const getClient = this.clientService.getClientByClientId(this.id);
    this.subscription = getClient.subscribe(response => {
      this.client = response;
      let clientUser = this.client;
      clientUser.users.sort((a, b) => {
        if (a.name == null) {
          a.name = '';
        }
        if (b.name == null) {
          b.name = '';
        }
        if (a.permissionGroups == '') {
          a.permissionGroups = 'Nenhum';
        }
        if (b.permissionGroups == '') {
          b.permissionGroups = 'Nenhum';
        }
        return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
      });
      this.users = new MatTableDataSource<User>(clientUser.users);

      let fund = this.client.funds;
      fund.sort((a, b) => {
        return a.code.toLowerCase() > b.code.toLowerCase() ? 1 : -1;
      });
      this.funds = new MatTableDataSource<Fund>(fund);
      this.users.sortingDataAccessor = (data, sortHeaderId) => {
        if (data[sortHeaderId] == null || data[sortHeaderId] == undefined) {
          data[sortHeaderId] = '';
        }
        return data[sortHeaderId].toLocaleLowerCase();
      };
      this.funds.sortingDataAccessor = (data, sortHeaderId) =>
        data[sortHeaderId].toLocaleLowerCase();
      this.sortUsers.disableClear = true;
      this.sortFunds.disableClear = true;
      this.sortUsers.sort({ id: 'name', start: 'asc' } as MatSortable);
      this.sortFunds.sort({ id: 'code', start: 'asc' } as MatSortable);
      this.users.sort = this.sortUsers;
      this.funds.sort = this.sortFunds;
    });
  }

  filterUsers(event: Event) {
    this.users.filterPredicate = (data, filter) => {
      if (data.name === null || data.name === undefined) {
        data.name = '';
      }
      return data.name.toLowerCase().includes(filter.toLowerCase());
    };

    this.userFilter = (event.target as HTMLInputElement).value;
    this.users.filter = this.userFilter;

    if (this.userFilter.length > 0 && this.userFilter.length % 2 == 0) {
      this.usersComplete = this.users.filteredData;
    } else if (this.userFilter.length == 0) {
      this.usersComplete = [];
    }
  }

  filterFunds(event?: Event) {
    this.funds.filterPredicate = (data, filter) => {
      return (
        data.code.toLowerCase().includes(filter.toLowerCase()) ||
        data.name.toLocaleLowerCase().includes(filter.toLocaleLowerCase())
      );
    };
    this.fundFilter = (event.target as HTMLInputElement).value;
    this.funds.filter = this.fundFilter;

    if (this.fundFilter.length > 0 && this.fundFilter.length % 2 == 0) {
      this.fundsComplete = this.funds.filteredData;
    } else if (this.fundFilter.length == 0) {
      this.fundsComplete = [];
    }
  }

  doFechar() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  protected handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}
